export const actions = {
    GET_PROFILE: 'GET_PROFILE',
    SET_PROFILE: 'SET_PROFILE',
    SET_PROFILE_PHOTO: 'SET_PROFILE_PHOTO',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    CHANGE_PASSWORD_SET: 'CHANGE_PASSWORD_SET',
    CHANGE_PASSWORD_QUESTION: 'CHANGE_PASSWORD_QUESTION',
    CHANGE_PASSWORD_QUESTION_SET: 'CHANGE_PASSWORD_QUESTION_SET',
    UPDATE_PROFILE_PHOTO_ACTION: 'UPDATE_PROFILE_PHOTO_ACTION',
    UPDATE_PROFILE_PHOTO_ACTION_SET: 'UPDATE_PROFILE_PHOTO_ACTION_SET',
    USER_PREFERENCES_GET: 'USER_PREFERENCES_GET',
    USER_PREFERENCES_SET: 'USER_PREFERENCES_SET',
    USER_PREFERENCES_ADDORUPDATE: 'USER_PREFERENCES_ADDORUPDATE',
    USER_GET_LANGUAGE: 'USER_GET_LANGUAGE',
    USER_SET_LANGUAGE: 'USER_SET_LANGUAGE',

    SET_LOGIN_USER_CULTURE: 'SET_LOGIN_USER_CULTURE',

    GET_TIMEZONE: 'GET_TIMEZONE',
    SET_TIMEZONE: 'SET_TIMEZONE',
};